/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext } from 'react';
import { Card, Col, Row, Container, Table } from 'react-bootstrap';
import { Text, Stack, Group, Space, Center, Button, Tabs, Switch } from '@mantine/core';
import { Pagination, Badge } from '@mantine/core';
import { TextInput } from '@mantine/core';
import {
  IconSearch,
  IconCopy,
  IconEdit,
  IconTrash,
  IconPhoto,
  IconMessageCircle,
  IconRefresh,
  IconSortAscending,
  IconSortDescending,
  IconArrowsSort,
} from '@tabler/icons';
import { ActionIcon } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { IconPlus } from '@tabler/icons';
import AddMaterial from '../ProjectRequest/AddMaterial';
import { UserContext } from '../../context/userContext';
import CustomCardLoader from '../../components/CustomCardLoader';
import moment from 'moment';
import { pageContext } from '../../context/pageContext';
import homeServices from '../../services/homeServices';
import { DateDifference, RowColors, formatChange } from '../../utils/Utils';

function MDMView3() {
  const navigate = useNavigate();

  const {
    searchMdmView3,
    setSearchMdmView3,
    mdmViewPagination3,
    setMdmViewPagination3,
    totalMdmView3,
    setTotalMdmView3,
  } = useContext(pageContext);

  // const [projectList, setProjectList] = useState([]);

  // useEffect(() => {
  //   let temp = [];
  //   projects?.map((project) => {
  //     project?.materials?.map((material) => {
  //       material.plants?.map((plant) => {
  //         temp.push({
  //           ...plant,
  //           project_type: project?.project_type,
  //           project_name: project?.project_name,
  //           project_year: project?.project_year,
  //           project_owner: project?.project_owner,
  //           material_status: material?.material_status,
  //           material_id: material?.id,
  //           rejected_comment: plant?.rejected_comment,
  //           sku_description: material?.sku_description,
  //           sku_id: material?.sku_id,
  //           fg_type: material?.fg_type,
  //           liquid: material?.liquid,
  //           m_deleted: material?.deleted,
  //           deleted: material?.deleted,
  //           pl_deleted: plant?.deleted,
  //           pr_deleted: project?.deleted,
  //           plant: plant?.plant,
  //           plant_status: plant?.status,
  //           plant_id: plant?.id,
  //           existing_item: material?.existing_item,
  //           existing_item_number: material?.existing_item_number,
  //           virtual_sku_description: material?.virtual_sku_description,
  //         });
  //       });
  //     });
  //   });

  //   console.log(
  //     'temp FILTERED 3.3',
  //     temp
  //       ?.filter((item) => item?.material_status == 4)
  //       ?.filter((item) => item?.deleted === false)
  //       ?.filter((item) => item?.p_bom_status == 4 || item?.l_bom_status == 2),
  //   );
  //   setProjectList(
  //     temp
  //       ?.filter((item) => item?.material_status == 4)
  //       ?.filter((item) => item?.deleted === false)
  //       ?.filter((item) => item?.p_bom_status == 4 || item?.l_bom_status == 2),
  //   );
  // }, [projects]);

  const [projectList, setProjectList] = useState([]);
  const [pages, setPages] = React.useState(0);
  const [loadingData, setLoadingData] = useState(false);
  const [sortedColumnData, setSortedColumnData] = useState(null);
  const [sortType, setSortType] = useState(null);

  const fetchData = async (offset, search, sort_column = null, sort_type = null) => {
    setSortedColumnData(sort_column);
    setSortType(sort_type);
    setLoadingData(true);
    homeServices
      .getSapBomCreationData({
        search: search,
        offset: (offset - 1) * 10,
        sort_column: sort_column,
        sort_type: sort_type,
      })
      .then((res) => {
        // console.log('PROJECT REQUEST DATA: ', res);
        setProjectList(res?.data);
        setPages(res?.total);
        setLoadingData(false);
        setTotalMdmView3(res?.rows);
      })
      .catch((err) => {
        // console.log('PROJECT REQUEST ERROR: ', err);
      });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData(1, searchMdmView3);
    }, 1500);
    return () => clearTimeout(timer);
  }, [searchMdmView3]);

  return (
    <div style={{ marginLeft: '1rem', marginRight: '1rem' }}>
      <Card radius="xl">
        <Card.Body>
          <Group position="apart">
            <Text size="xl" weight={700} color="yellow" align="left" style={{ fontSize: '18px' }}>
              {}
            </Text>
          </Group>
        </Card.Body>
        <Card.Body>
          <Group position="apart">
            <Text
              size="xl"
              weight={700}
              color="yellow"
              style={{ fontSize: '18px' }}
            >{`SAP BOMs Creation`}</Text>
          </Group>
          <Space h="xl" />
          <TextInput
            radius={'xl'}
            placeholder={`SKU ID`}
            sx={{ width: '16vw' }}
            rightSection={
              <ActionIcon
                variant="filled"
                color={'yellow'}
                radius="xl"
                size="md"
                onClick={() => {
                  setSearchMdmView3('');
                  setMdmViewPagination3(1);
                }}
              >
                <IconRefresh size={14} color="black" />
              </ActionIcon>
            }
            onChange={(e) => {
              setLoadingData(true);
              setSearchMdmView3(e.target.value);
              setMdmViewPagination3(1);
            }}
            value={searchMdmView3}
          />
        </Card.Body>
        {loadingData ? (
          <CustomCardLoader />
        ) : (
          <div className="table-responsive-sm">
            <Table hover>
              <thead>
                <tr>
                  {[
                    'SKU ID',
                    'SKU Description',
                    'Hold',
                    'Plant',
                    'Production Date',
                    'Due Date',
                    'Days To Production',
                  ].map((item, index) => (
                    <th key={index}>
                      <Center fw={500}>
                        {item}
                        <>
                          {sortedColumnData !== item && (
                            <ActionIcon
                              onClick={() => {
                                fetchData(1, searchMdmView3, item, 'ascending');
                              }}
                            >
                              <IconArrowsSort />
                            </ActionIcon>
                          )}
                          {sortedColumnData == item && sortType == 'ascending' && (
                            <ActionIcon
                              onClick={() => {
                                fetchData(1, searchMdmView3, item, 'descending');
                              }}
                            >
                              <IconSortAscending />
                            </ActionIcon>
                          )}
                          {sortedColumnData == item && sortType == 'descending' && (
                            <ActionIcon
                              onClick={() => {
                                fetchData(1, searchMdmView3, null, null);
                              }}
                            >
                              <IconSortDescending />
                            </ActionIcon>
                          )}
                        </>
                      </Center>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {projectList?.map((project, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      navigate(
                        `/material/${project?.material_id}/${project?.plant_id}`,
                        //   {
                        //   state: {
                        //     plant_id: project?.plant_id,
                        //     plant: project?.plant,
                        //     status: project?.plant_status,
                        //   },
                        // }
                      );
                    }}
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <td>
                      {project?.existing_item === 'Yes'
                        ? project?.existing_item_number
                        : project?.sku_id}
                    </td>
                    <td>
                      {
                        // project?.fg_type === 'Virtual'
                        // ? project?.virtual_sku_description
                        //   :
                        project?.sku_description
                      }
                    </td>
                    <td>
                      <Switch label="Hold" size="xs" color="yellow" checked={project?.on_hold} />
                    </td>
                    <td>{project?.plant}</td>
                    <td>
                      {project?.production_date
                        ? moment(project?.production_date).format('MM-DD-YYYY')
                        : ''}
                    </td>
                    <td>
                      {project?.due_date_by
                        ? formatChange(project?.due_date_by)
                        : ''}
                    </td>
                    <td>{RowColors(DateDifference(project?.production_date))}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
        <Card.Footer>
          <Container>
            <Center>
              <Pagination
                total={pages + 1}
                color="yellow"
                radius="xl"
                withEdges
                page={mdmViewPagination3}
                boundaries={1}
                initialPage={mdmViewPagination3}
                value={mdmViewPagination3}
                onChange={(e) => {
                  // console.log(e);
                  setMdmViewPagination3(e);
                  fetchData(e, searchMdmView3, sortedColumnData, sortType);
                }}
              />
            </Center>
          </Container>
        </Card.Footer>
      </Card>
    </div>
  );
}
export default MDMView3;
